export interface PasswordValidation {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasSpecialChar: boolean;
  passwordsMatch: boolean;
}

export interface PasswordRequirements {
  key: keyof PasswordValidation;
  label: string;
  isValid: boolean;
}

export const validatePassword = (password: string): PasswordValidation => {
  return {
    hasMinLength: password.length >= 12,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
    passwordsMatch: false, // This will be set separately when comparing passwords
  };
};

export const validatePasswordMatch = (
  password: string,
  confirmPassword: string
): boolean => {
  return password === confirmPassword && password.length > 0;
};

export const getPasswordRequirements = (
  password: string,
  confirmPassword?: string
): PasswordRequirements[] => {
  const validation = validatePassword(password);

  if (confirmPassword !== undefined) {
    validation.passwordsMatch = validatePasswordMatch(
      password,
      confirmPassword
    );
  }

  return [
    {
      key: "hasMinLength",
      label: "12+ characters",
      isValid: validation.hasMinLength,
    },
    {
      key: "hasUppercase",
      label: "At least 1 uppercase letter",
      isValid: validation.hasUppercase,
    },
    {
      key: "hasLowercase",
      label: "At least 1 lowercase letter",
      isValid: validation.hasLowercase,
    },
    {
      key: "hasSpecialChar",
      label: "At least 1 special character",
      isValid: validation.hasSpecialChar,
    },
    {
      key: "passwordsMatch",
      label: "Passwords match",
      isValid: validation.passwordsMatch,
    },
  ];
};

export const isPasswordValid = (
  requirements: PasswordRequirements[]
): boolean => {
  return requirements.every((requirement) => requirement.isValid);
};
